/**
 * To localize Shopify product data
 * @param {Object} product
 * @returns {Object}
 */
export const toLocaliseShopifyProductData = product => {
  const { maxVariantPricing } = product.contextualPricing || {}

  return {
    title: product.translations?.title || product.title,
    description: product.translations?.body_html || product.descriptionHtml,
    maxVariantPrice: maxVariantPricing?.price.amount,
    maxVariantPriceCurrencyCode: maxVariantPricing?.price.currencyCode,
  }
}

/**
 * To localize Shopify variant data
 * @param {Object} variant
 * @returns {Object}
 */
export const toLocaliseShopifyVariantData = variant => {
  const { compareAtPrice, price } = variant?.contextualPricing || {}

  return {
    title:
      (variant.translations && Object.values(variant.translations)[0]) ||
      variant.title,
    price: price?.amount || null,
    priceCurrencyCode: price?.currencyCode || null,
    compareAtPrice: compareAtPrice?.amount || null,
    compareAtPriceCurrencyCode: compareAtPrice?.currencyCode || null,
  }
}
